import { declOfNum } from '../../../../../helpers/dspx-utils';
import { fieldNames } from './constants';

export const formValuesChange = (props, changedValues, allValues) => {
  const date = allValues[fieldNames.verificationDate];
  const interval = allValues[fieldNames.verificationInterval];

  if (
    fieldNames.verificationDate in changedValues ||
    fieldNames.verificationInterval in changedValues
  ) {
    const nextDate =
      date && interval ? date.clone().add(Number(interval), 'months') : null;

    props.form.setFieldsValue({
      [fieldNames.nextVerificationDate]: nextDate,
    });
  }
};

export const getRequiredRule = (message, type = 'string') => {
  const rule = {
    required: true,
    message,
    type,
  };

  if (type === 'string') {
    rule.whitespace = true;
  }

  return rule;
};

export const getTextValidator =
  ({ maxLength, pattern }) =>
  (_rule, value, callback) => {
    if (!value?.trim()) {
      return callback();
    }

    if (maxLength && value.length > maxLength) {
      const maxText = `${maxLength} ${declOfNum(maxLength, [
        'символ',
        'символа',
        'символов',
      ])}`;

      return callback(
        `Значение не должно быть больше ${maxText}. Сейчас - ${value.length}`
      );
    }

    if (pattern && !pattern.test(value)) {
      return callback(`Поле содержит недопустимые символы`);
    }

    callback();
  };
